export default __webpack_public_path__ + "static/media/No888Open.b665290f.jpg";